import styled from "styled-components";
import { media } from "../../theme/theme";

export const TopBarWithCopyWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 180px;

    ${media.custom(600)} {
        min-width: 300px;
    }

    > div {

        &:first-child {
            width: 100%;
        }

        &:nth-child(2) {
            margin-left: 5px;

            &:hover {
                svg {
                    path {
                        stroke: ${({ theme }) => theme ? theme.v3.colors.blue : null};
                    }
                }
            }
        }
    }
`;

export const TopBarWithCopyIconSpacer = styled.div`
    padding: 5px;
`;